// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.about-container h1 {
  margin-bottom: 2rem;
  font-size: 52px;
  color: #323232;
  font-family: 'AlternateGot', Arial, sans-serif;
}

.about-content {
  font-size: 32px;
  line-height: 1.5;
  color: #676a6a;
  font-family: 'AlternateGot', Arial, sans-serif;
}

.about-paragraph {
  margin-bottom: 1.5rem;
}

.about-footnote {
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 24px;
  color: #999999;
  font-style: italic;
  line-height: 1.4;
}

.about-center {
  text-align: center;
}

.about-left {
  text-align: left;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .about-container {
    padding: 1rem;
  }
  
  .about-container h1 {
    font-size: 36px;
  }
  
  .about-content {
    font-size: 24px;
  }
  
  .about-footnote {
    font-size: 18px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/About.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".about-container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 2rem;\r\n}\r\n\r\n.about-container h1 {\r\n  margin-bottom: 2rem;\r\n  font-size: 52px;\r\n  color: #323232;\r\n  font-family: 'AlternateGot', Arial, sans-serif;\r\n}\r\n\r\n.about-content {\r\n  font-size: 32px;\r\n  line-height: 1.5;\r\n  color: #676a6a;\r\n  font-family: 'AlternateGot', Arial, sans-serif;\r\n}\r\n\r\n.about-paragraph {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.about-footnote {\r\n  margin-top: 2rem;\r\n  margin-bottom: 1rem;\r\n  font-size: 24px;\r\n  color: #999999;\r\n  font-style: italic;\r\n  line-height: 1.4;\r\n}\r\n\r\n.about-center {\r\n  text-align: center;\r\n}\r\n\r\n.about-left {\r\n  text-align: left;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .about-container {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .about-container h1 {\r\n    font-size: 36px;\r\n  }\r\n  \r\n  .about-content {\r\n    font-size: 24px;\r\n  }\r\n  \r\n  .about-footnote {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
